var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":_vm.path}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }